import {
    AnyImageOpContext,
    ImageOpDefinition,
    ImageOpInputsOrNodes,
    ImageOpNode,
    ImageOpOutputs,
} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {Evaluator} from "@cm/graph-v3"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"

export abstract class CompositeImageOpNode<Definition extends ImageOpDefinition> extends ImageOpNode<Definition> {
    protected abstract execute(evaluator: Evaluator<AnyImageOpContext>, imageOpNodeBag: ImageOpNodeBag): Promise<ImageOpOutputs<Definition>>

    constructor(parameters: ImageOpInputsOrNodes<Definition>) {
        super(parameters)
    }

    override set debugId(debugId: string | undefined) {
        super.debugId = debugId
        this.imageOpNodeBag.debugId = debugId
    }

    override get debugId(): string | undefined {
        return super.debugId
    }

    override dispose() {
        this.imageOpNodeBag.dispose()
        super.dispose()
    }

    override run = async (evaluator: Evaluator<AnyImageOpContext>): Promise<ImageOpOutputs<Definition>> => {
        this.imageOpNodeBag.beginFrame()
        const result = await this.execute(evaluator, this.imageOpNodeBag)
        this.imageOpNodeBag.endFrame()
        return result
    }

    private imageOpNodeBag = new ImageOpNodeBag("CompositeImageOpNode")
}
